angular.module("vgresiduos").controller("OrganizationResidueEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `organizacao/residuo/${$stateParams.id}`);
		};
	}
]);
